import React from 'react';
import renderHTML from 'react-render-html';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import './plan-item.css';


const PlanItem = (props) => {
  const {
    item: {
      title,
      summaryList,
      subTitle,
      benefits,
      idealForText,
      footetText,
    },
    customClass,
    planTitle,
    noPlanFound,
  } = props;

  const benefitsList = () => {
    const list = benefits.map((benefit, index) => (
      <li className="heading16 account-label-text" key={`benefit-item-${index + 1}`} >
        <SvgIcon name="icon-system-ui-tick" className="svg" />
        {benefit}
      </li>
    ));
    return list;
  };


  const summaryListHtml = () => {
    const list = summaryList.map((benefit, index) => (
      <li className="heading16 account-label-text" key={`summary-item-${index + 1}`}>
        <SvgIcon name="icon-system-ui-tick" className="svg" />
        {benefit}
      </li>
    ));
    return list;
  };

  return (
    <div className="col-md-4 plan-details-item">
      <div className={`plan-item tl-animate1 ${customClass}`}>
        <div className="heading24 original-plan-name paddingM pt-0 pb-0">{planTitle}</div>
        <div className="paddingM">
          <div className="heading24 plan-heading">{title}</div>
          <div className="heading16 paddingXXS pl-0 pr-0 pb-0">{renderHTML(subTitle)}</div>
          {noPlanFound === false && (
            <React.Fragment>
              <hr className="divider marginS ml-0 mr-0" />
              <div className="body14 ideal-for paddingXXS pl-0 pr-0 pt-0">{idealForText}</div>
              <ul className="plan-benefits-list pt-0 pl-0 pr-0 pb-0 mb-0">
                {benefitsList()}
              </ul>
              <hr className="divider marginM ml-0 mr-0 mb-0" />
              <ul className="plan-summary-list paddingS pl-0 pr-0 pb-0">
                {summaryListHtml()}
              </ul>
              <div className="body14 ideal-for">{footetText}</div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanItem;
